import React from "react";
import Unsubscribe from "@/components/unsubscribe/Unsubscribe";
import MetaComponent from "@/components/common/MetaComponent";

const metadata = {
  title: "Hubzu | Unsubscribe",
};

const UnsubscribeScreen = () => {
  return (
    <>
      <MetaComponent meta={metadata} />
      <Unsubscribe />
    </>
  );
};

export default UnsubscribeScreen;
